// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"16dd21d9","581":"4ceb49c6","763":"88c9ffab","938":"5cca1e9e"}[chunkId] + ".chunk.js";
};